<jhi-modal title="{{ 'study-editor.import-design.import-file.title' | translate }}" [disabled]="isSaving">
    <div class="modal-body">
        <div class="row pt-2">
            <div class="col"><span class="fw-bold">{{ 'study-editor.review-design.heading' | translate | uppercase}}</span></div>
        </div>
        <div class="row pt-2">
            <div class="col">
                <span>{{ 'study-editor.review-design.type-of-design' | translate}}</span><span>{{ 'study-editor.review-design.externally-generated-design' | translate }}</span>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col">
                <div class="d-flex align-items-center">
                    <span class="me-2" jhiTranslate="global.records.per.page">Records per page:</span>
                    <select class="form-select form-select-sm" style="width: auto;"
                            (change)="onPageSizeChange($event)">
                        @for (option of pageSizeOptions; track option) {
                            <option [value]="option" [selected]="pageSize === option">{{ option }}</option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="row pt-1">
            <div class="col">
                @if (mappedHeader && importedData) {
                    <div class="table-responsive mt-3">
                        <div class="custom-scroll-style" style="max-height: 500px; overflow-y: auto; overflow-x: auto;">
                            <table id="review-design-table"
                                   class="table table-striped table-bordered table-curved">
                                <thead class="sticky-header">
                                <tr>
                                    @for (header of mappedHeader; track header.name) {
                                        <th scope="col">
                                            <span>{{header?.variable?.name}}</span>
                                        </th>
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                <!-- Use pagedData instead of importedData -->
                                <tr *ngFor="let row of pagedData; let i = index">
                                    @for (header of mappedHeader; track header.name) {
                                        <td>
                                            <span>{{ getCellDisplayValue(row, header) }}</span>
                                        </td>
                                    }
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Pagination controls -->
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div>
								<span jhiTranslate="study-editor.pagination.entry-count"
									  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, totalItems), param3: totalItems}"></span>
                            </div>
                            <ngb-pagination
                                    [collectionSize]="totalItems"
                                    [(page)]="currentPage"
                                    [pageSize]="pageSize"
                                    [maxSize]="5"
                                    [rotate]="true"
                                    [boundaryLinks]="true"
                                    (pageChange)="onPageChange($event)">
                            </ngb-pagination>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isSaving">
            <span translate="cancel"></span>
        </button>
        <button (click)="finish()" class="btn btn-primary" [disabled]="isSaving || !importedData">
            <span *ngIf="isSaving" class="throbber throbber-btn"></span>
            <span translate="continue"></span>
        </button>
    </div>
</jhi-modal>
